// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"16":"0cfe34e8","56":"a2be59d5","184":"1636be9f","207":"4589e839","350":"7a9248cc","367":"d5ff82fe","514":"bba665da","607":"c87ce63a","693":"6e5f3c10","877":"b1f64c3f","973":"46f6d38f"}[chunkId] + ".js";
};